module.exports = __webpack_public_path__ + "media/images/icons/filled/tablet-85bc46ae77039f909a1bff9971768255.svg";